module.exports = __webpack_public_path__ + "img/2.e73e87dc.png";